import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../shared/utils';
import store from '../../store';

export const reportCardClick = (industryTitle: string) => {
    mixpanel.track('Logo Maker - MP Entry Point - Click', {
        ...getDataFromStores(
            store.listingsType,
            store.searchQuery,
            store.sourcePage,
            store.position,
            store.page
        ),
        [MIXPANEL_EVENT_PROPERTIES.CTA_CLICKED]: industryTitle,
    });
};
